<template>
    <div v-if="settings_status == 'success'">
        <form @submit.prevent="updateSettings" id="settings_form">
            <div id="message_div"></div>
            <kt-row>
                <kt-col lg="3" md="4" sm="12">
                    <kt-form-group>
                        <kt-form-label for="priority">
                            {{ $t('label.priority') }}
                        </kt-form-label>
                        <kt-form-select
                                id="priority"
                                name="priority"
                                v-model="general_settings.priority"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-bind:key="index"
                                    v-for="(priority, index) in priorities"
                                    v-bind:value="priority.value"
                            >
                                {{ priority.title }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col v-if="general_settings.priority == 1" lg="3" md="4" sm="12">
                    <kt-form-group>
                        <kt-form-label for="priority_type">
                            {{ $t('label.priority_type') }}
                        </kt-form-label>
                        <kt-form-select
                                id="priority_type"
                                name="priority_type"
                                v-model="general_settings.priority_type"
                                class="form-control kt-selectpicker"
                                @change="refresh"
                        >
                            <option
                                    v-bind:key="index"
                                    v-for="(priority_type, index) in priority_types"
                                    v-bind:value="priority_type.value"
                            >
                                {{ priority_type.title }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col v-if="general_settings.priority == 1" lg="3" md="4" sm="12">
                    <kt-row v-if="general_settings.priority_type == 1">
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="first_priority">
                                    {{ $t('label.first_priority') }}
                                </kt-form-label>
                                <kt-form-select
                                        id="first_priority"
                                        name="first_priority"
                                        v-model="general_settings.first_priority"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(gateway, index) in gateways"
                                            v-bind:value="gateway.id"
                                    >
                                        {{ gateway.farsi_name + ' - ' + getPSPName(gateway.psp) }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="second_priority">
                                    {{ $t('label.second_priority') }}
                                </kt-form-label>
                                <kt-form-select
                                        id="second_priority"
                                        name="second_priority"
                                        v-model="general_settings.second_priority"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(gateway, index) in gateways"
                                            v-bind:value="gateway.id"
                                    >
                                        {{ gateway.farsi_name + ' - ' + getPSPName(gateway.psp) }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="third_priority">
                                    {{ $t('label.third_priority') }}
                                </kt-form-label>
                                <kt-form-select
                                        id="third_priority"
                                        name="third_priority"
                                        v-model="general_settings.third_priority"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(gateway, index) in gateways"
                                            v-bind:value="gateway.id"
                                    >
                                        {{ gateway.farsi_name + ' - ' + getPSPName(gateway.psp) }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                    <kt-row v-else-if="general_settings.priority_type == 0">
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="first_priority">
                                    {{ $t('label.first_priority') }}
                                </kt-form-label>
                                <kt-form-select
                                        id="first_priority"
                                        name="first_priority"
                                        v-model="general_settings.first_priority"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(psp, index) in pspLoopList"
                                            v-bind:value="psp.value"
                                    >
                                        {{ psp.title }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="second_priority">
                                    {{ $t('label.second_priority') }}
                                </kt-form-label>
                                <kt-form-select
                                        id="second_priority"
                                        name="second_priority"
                                        v-model="general_settings.second_priority"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(psp, index) in pspLoopList"
                                            v-bind:value="psp.value"
                                    >
                                        {{ psp.title }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="12" md="12" sm="12">
                            <kt-form-group>
                                <kt-form-label for="third_priority">
                                    {{ $t('label.third_priority') }}
                                </kt-form-label>
                                <kt-form-select
                                        id="third_priority"
                                        name="third_priority"
                                        v-model="general_settings.third_priority"
                                        class="form-control kt-selectpicker"
                                >
                                    <option
                                            v-bind:key="index"
                                            v-for="(psp, index) in pspLoopList"
                                            v-bind:value="psp.value"
                                    >
                                        {{ psp.title }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
            <kt-form-action class="mt-2">
                <button class="btn btn-md btn-success btn-wide" type="submit" id="change_settings_btn">
                    {{ $t('btn.edit') }}
                </button>
            </kt-form-action>
        </form>
    </div>
</template>

<script>
import $ from "jquery"
import { i18n } from '@/plugins/i18n'
import {mapGetters} from "vuex"
import {pspLoopList} from "@/constants/psp";
import { KTApp } from '@/plugins/core/app'
import { collectiveService } from '@/common/api.service'

export default {
    computed: {
        ...mapGetters('collective', [
            'general_settings',
            'settings_status',
            'gateways'
        ])
    },
    mounted() {
        this.$store.dispatch('collective/fetchGeneralSettings')
            .finally(() => {
                this.afterDispatch()
            })
    },
    data() {
        return {
            pspLoopList,
            priorities: [
                {
                    value: 0,
                    title: i18n.t('priority.random')
                },
                {
                    value: 1,
                    title: i18n.t('priority.with_priority')
                },
            ],
            priority_types: [
                {
                    value: 0,
                    title: i18n.t('priority_type.by_psp')
                },
                {
                    value: 1,
                    title: i18n.t('priority_type.by_gateway')
                },
            ],
        }
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        refresh() {
            this.general_settings.priority = 0
            let general_settings = this.general_settings
            setTimeout(function () {
                general_settings.priority = 1
            }, 100)
        },
        getPSPName(psp) {
                return i18n.t('psp_list.' + psp)
        },
        updateSettings(){
            let btn = $('#change_settings_btn')
            let form = $('#message_div')
            KTApp.progress(btn)

            collectiveService.updateSettings(this.general_settings).then(response => {
                this.showMsg(form, 'success', i18n.t('message.edit_success'))
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(response => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style>

</style>